import React, { useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../elements/Card';
import LoadingBars from '../../elements/LoadingBars';
import { fetchProvinces } from '../../layouts/PageBase/actions';
import { getChartOptions } from './constans';
import styles from './styles.scoped.css';

function ChartReportTrasaction() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProvinces());
  }, []);

  const {
    dataChartReport: { cities = [], data = [] },
    isLoadingChartReport,
  } = useSelector((s) => s.home);

  return (
    <Card className={styles.graph}>
      <div className={styles['header']}>
        <h5>Rata-rata Transaksi</h5>
        <div className={styles['filter-wrap']}>
          Jumlah Rata-rata: 90 Tabung
        </div>
      </div>
      {isLoadingChartReport ? (
        <div className={styles['loading-container']}>
          <LoadingBars size={10} />
        </div>
      ) : (
        <Bar
          data={{
            labels: cities,
            datasets: [
              {
                data,
                backgroundColor: 'rgba(68, 171, 73, 1)',
                hoverBackgroundColor: 'rgba(198, 229, 199, 0.8)',
              },
            ],
          }}
          options={getChartOptions()}
        />
      )}
    </Card>
  );
}

export default ChartReportTrasaction;
